import * as React from 'react';

interface Props {
  onClick: () => void;
  title?: string;
}

/**
 * Renders an `li` containing clickable content.
 */
export const SelectableListItem: React.FC<Props> = ({
  children,
  onClick,
  title,
}) => {
  return (
    <li>
      <button
        title={title}
        onClick={onClick}
        type="button"
        className="block w-full bg-transparent border-grey-200 border-t p-4 sm:px-0 hover:text-grey-500 transition cursor-pointer text-left space-y-2"
      >
        {children}
      </button>
    </li>
  );
};
